import React, { useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar/Sidebar';
import Header from './Header/Header';
import Dashboard from '../../pages/Dashboard';
import Settings from '../../pages/Settings';
import Users from '../../pages/Users';
import AlpacaPortfolio from '../../pages/AlpacaPortfolio';
import AlpacaAssets from '../../pages/AlpacaAssets';
import AssetHistoryCheck from '../../pages/AssetHistoryCheck';
import TopGainers from '../../pages/TopGainers';
import AiSignals from '../../pages/AiSignals';
import AlpacaBot from '../../pages/AlpacaBot';
import AlpacaConfig from '../../pages/AlpacaConfig';
import SymbolChart from '../../pages/SymbolChart';
import NotificationsTelegram from '../../pages/NotificationsTelegram';
import Crons from '../../pages/Crons';
import Emails from '../../pages/Emails';
import OllamaChat from '../../pages/OllamaChat';
import BotLogs from '../../pages/BotLogs';
import ProtectedRoute from '../auth/ProtectedRoute';
import './AdminLayout.css';

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="admin-layout">
      <Sidebar isOpen={sidebarOpen} onToggle={toggleSidebar} />
      <div className={`main-content ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <Header sidebarOpen={sidebarOpen} onToggleSidebar={toggleSidebar} />
        <main className="content">
          <Routes>
            {/* Routes accessibles à tous les utilisateurs authentifiés */}
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="settings" element={<Settings />} />
            
            {/* Routes nécessitant ROLE_ADMIN */}
            <Route path="users" element={
              <ProtectedRoute requiredRole="ROLE_ADMIN">
                <Users />
              </ProtectedRoute>
            } />
            <Route path="alpaca/config" element={<AlpacaConfig />} />
            <Route path="alpaca/bot" element={<AlpacaBot />} />
            <Route path="alpaca/portfolio" element={
              <ProtectedRoute requiredRole="ROLE_ADMIN">
                <AlpacaPortfolio />
              </ProtectedRoute>
            } />
            <Route path="alpaca/assets" element={
              <ProtectedRoute requiredRole="ROLE_ADMIN">
                <AlpacaAssets />
              </ProtectedRoute>
            } />
            <Route path="alpaca/history-check" element={
              <ProtectedRoute requiredRole="ROLE_ADMIN">
                <AssetHistoryCheck />
              </ProtectedRoute>
            } />
            <Route path="alpaca/top-gainers" element={
              <ProtectedRoute requiredRole="ROLE_ADMIN">
                <TopGainers />
              </ProtectedRoute>
            } />
            <Route path="alpaca/ai-signals" element={
              <ProtectedRoute requiredRole="ROLE_ADMIN">
                <AiSignals />
              </ProtectedRoute>
            } />
            <Route path="alpaca/symbol-chart" element={<SymbolChart />} />
            <Route path="notifications/telegram" element={
              <ProtectedRoute requiredRole="ROLE_ADMIN">
                <NotificationsTelegram />
              </ProtectedRoute>
            } />
            <Route path="crons" element={
              <ProtectedRoute requiredRole="ROLE_ADMIN">
                <Crons />
              </ProtectedRoute>
            } />
            <Route path="emails" element={<Emails />} />
            <Route path="ollama-chat" element={<OllamaChat />} />
            <Route path="bot-logs" element={<BotLogs />} />
            <Route path="" element={<Dashboard />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
